import { useContext } from 'react';
import GlobalTabsContext from '../GlobalTabsContext';

export const useGlobalTabsContext = () => {
  const data = useContext(GlobalTabsContext);
  return data;
};
